module.exports = __webpack_public_path__ + "img/icon_highlight_xblyhu.166dfe69.png";